import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationFastapiService } from '../../services/authentication-fastapi.service';
import { UiService } from '../../services/ui.service';
import { PasswordlessTokenResponse } from '../../models/passwordless-token-response';
import { RestPasswordlessTokenResponse } from '../../models/rest-responses';
import { UserService, LoginData } from '@arpada/arp-lib-common-qupro';

@Component({
  selector: 'app-login-passwordless',
  templateUrl: './login-passwordless.page.html',
  styleUrls: ['./login-passwordless.page.scss'],
})
export class LoginPasswordlessPage implements OnInit {
  passwordlessToken!: string;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthenticationFastapiService,
    private uiService: UiService,
    private userService: UserService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe(q => {
      this.passwordlessToken = q.get('passwordless_token');
      // console.log('passwordlessToken:', this.passwordlessToken);
      this.authService.loginWithPasswordlessToken(this.passwordlessToken).subscribe((response: RestPasswordlessTokenResponse) => {
        // console.log('Response from passwordless login:', response);
        const passwordlessTokenResponse: PasswordlessTokenResponse = {
          access_token: response.access_token,
          login_email: response.login_email
        };
        // console.log('PasswordlessTokenResponse:', passwordlessTokenResponse);
        const password = 'TOKEN-' + passwordlessTokenResponse.access_token;
        // console.log('Generated password for login:', password);
        this.userService.loginUsuario(passwordlessTokenResponse.login_email, password).subscribe((loginData: LoginData) => {
          // console.log('Login successful:', loginData);
          this.router.navigate(['/main/listado-incidencias']);

        }, error => {
          console.error('Login error:', error);
          this.uiService.presentAlert('Login Error', null, error.message);
        }
      );
      }, error => {
        console.error('Error during passwordless login:', error);
        this.uiService.presentAlert('Error', null, error.error.message);
      });
      // con la respuesta ok hacer un login silencioso y redirigir a main
    });
  }

}
